import script from "./HeaderTwa.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderTwa.vue?vue&type=script&setup=true&lang=js"

import "./HeaderTwa.vue?vue&type=style&index=0&id=fd0868bc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd0868bc"]])

export default __exports__